import request from '@/utils/request'

export function addCompanyDic(data) {
    return request({
        url: '/db/company-dic/add',
        method: 'post',
        data
    })
}

export function deleteCompanyDic(data) {
    return request({
        url: '/db/company-dic/delete',
        method: 'post',
        data
    })
}

export function queryCompanyDic(data) {
    return request({
        url: '/db/company-dic/query',
        method: 'post',
        data
    })
}

export function updateCompanyDic(data) {
    return request({
        url: '/db/company-dic/update',
        method: 'post',
        data
    })
}

